import axios from "axios";
import { API_GATEWAY, PR_DEP } from "../../config/globalVariables";

class EventTypeService {
  getList() {
    return axios
      .get(`${API_GATEWAY + PR_DEP}/etkinliktipi/get-list`)
      .then((response) => {
        return response.data;
      });
  }
  getListByBolumKodu(bolumKodu) {
    return axios
      .get(
        `${API_GATEWAY + PR_DEP}/etkinliktipi/get-by-bolum-kodu/${bolumKodu}`
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new EventTypeService();
